import React from 'react';
import { Link } from 'react-router-dom';
import Button from './ui/button';

const ThreeContainersSection = () => {
  return (
    <section className="w-full">
      <div className="grid grid-cols-1 lg:grid-cols-3 min-h-[500px] sm:min-h-[700px] lg:min-h-[800px]">
        {/* Consultancy Container */}
        <div className="flex flex-col">
          {/* Photo Section - 30% */}
          <div
            className="h-[150px] sm:h-[240px] lg:h-[30%] bg-cover bg-center bg-no-repeat relative flex items-center justify-start p-3 sm:p-6"
            style={{
              backgroundImage: "url('/images/lloyd-james-data-consuntancy-countryside-house.jpg')"
            }}
          >
            {/* Overlay */}
            <div
              className="absolute inset-0"
              style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
            />
            <h2 className="text-white text-2xl sm:text-3xl lg:text-4xl font-bold drop-shadow-lg relative z-10">Consultancy</h2>
          </div>
          
          {/* Text Section - 70% */}
          <div
            className="flex-1 lg:h-[70%] flex flex-col justify-between p-6 sm:p-8 lg:p-12"
            style={{ backgroundColor: '#8b1538' }}
          >
            <div>
              <h3 className="text-white text-xl sm:text-2xl lg:text-3xl font-bold mb-4 sm:mb-6 leading-tight">
                Be braver as a business with the reassurance of insight.
              </h3>
              <p className="text-white text-sm sm:text-base lg:text-base leading-relaxed mb-6 sm:mb-8">
                Data is only ever data, unless it's high quality, accurate and brought to life in the right way.
              </p>
            </div>
            <Link to="/data-consultancy" onClick={() => window.scrollTo(0, 0)}>
              <Button variant="primary" size="medium" className="self-start">
                Find out more
              </Button>
            </Link>
          </div>
        </div>

        {/* Resident Container */}
        <div className="flex flex-col">
          {/* Photo Section - 30% */}
          <div
            className="h-[200px] sm:h-[240px] lg:h-[30%] bg-cover bg-center bg-no-repeat relative flex items-center justify-start p-4 sm:p-6"
            style={{
              backgroundImage: "url('/images/resident-lloyd-james-data-consultancy.jpg')"
            }}
          >
            {/* Overlay */}
            <div
              className="absolute inset-0"
              style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
            />
            <h2 className="text-white text-2xl sm:text-3xl lg:text-4xl font-bold drop-shadow-lg relative z-10">RESIDENT</h2>
          </div>
          
          {/* Text Section - 70% */}
          <div
            className="flex-1 lg:h-[70%] flex flex-col justify-between p-6 sm:p-8 lg:p-12"
            style={{ backgroundColor: '#990f67' }}
          >
            <div>
              <h3 className="text-white text-xl sm:text-2xl lg:text-3xl font-bold mb-4 sm:mb-6 leading-tight">
                51 million consumers;<br />
                400 attributes;<br />
                endless possibilities.
              </h3>
              <p className="text-white text-sm sm:text-base lg:text-base leading-relaxed mb-6 sm:mb-8">
                With our market-leading data service, RESIDENT, we're able to provide you with a single view of the UK covering 96% of all UK households and 51 million individuals. But it's not the volume of our data that's impressive – it's the accuracy, quality and how we use it that sets us apart.
              </p>
            </div>
            <Link to="/product" onClick={() => window.scrollTo(0, 0)}>
              <Button variant="primary" size="medium" className="self-start">
                Find out more
              </Button>
            </Link>
          </div>
        </div>

        {/* Evidence Container */}
        <div className="flex flex-col">
          {/* Photo Section - 30% */}
          <div
            className="h-[200px] sm:h-[240px] lg:h-[30%] bg-cover bg-center bg-no-repeat relative flex items-center justify-start p-4 sm:p-6"
            style={{
              backgroundImage: "url('/images/evidence-data-lloyd-james-data-consultancy.JPG')"
            }}
          >
            {/* Overlay */}
            <div
              className="absolute inset-0"
              style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
            />
            <h2 className="text-white text-2xl sm:text-3xl lg:text-4xl font-bold drop-shadow-lg relative z-10">Evidence</h2>
          </div>
          
          {/* Text Section - 70% */}
          <div
            className="flex-1 lg:h-[70%] flex flex-col justify-between p-6 sm:p-8 lg:p-12"
            style={{ backgroundColor: '#3c048e' }}
          >
            <div>
              <h3 className="text-white text-xl sm:text-2xl lg:text-3xl font-bold mb-4 sm:mb-6 leading-tight">
                Data provider?<br />
                Full-service agency?<br />
                Growth provider?<br />
                How about all<br />
                of the above.
              </h3>
              <p className="text-white text-sm sm:text-base lg:text-base leading-relaxed mb-6 sm:mb-8">
                With people at the heart of everything we do – whether that's our customers or our own employees – we're able to unlock the power of data marketing and use it to deliver tangible business outcomes. Why not see the evidence for yourself?
              </p>
            </div>
            <Link to="/evidence" onClick={() => window.scrollTo(0, 0)}>
              <Button variant="primary" size="medium" className="self-start">
                Find out more
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThreeContainersSection;